(function () {
    

    angular
        .module('app')
        .directive('heroGradient', heroGradient);

    heroGradient.$inject = ['$window'];

    function heroGradient($window) {
        // Usage:
        //     <heroGradient></heroGradient>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA'
        };
        return directive;

        function link(scope, element, attrs) {
            /* Animated Gradient */
            var colors = new Array(
                [74, 97, 152], //blue
                [152, 54, 124], //purple
                [202, 50, 71], //red
                [23, 131, 143], //teal
                [80, 186, 112], //neon green
                [193, 216, 47]); //yellow-green

            var step = 0;
            //color table indices for: 
            // current color left
            // next color left
            // current color right
            // next color right
            var colorIndices = [0, 1, 2, 3, 4, 5];

            //transition speed
            var gradientSpeed = 0.002;

            var isIE = window.navigator.msPointerEnabled;

            function updateGradient() {

                if ($ === undefined) return;

                var c0_0 = colors[colorIndices[0]];
                var c0_1 = colors[colorIndices[1]];
                var c1_0 = colors[colorIndices[2]];
                var c1_1 = colors[colorIndices[3]];

                var istep = 1 - step;
                var r1 = Math.round(istep * c0_0[0] + step * c0_1[0]);
                var g1 = Math.round(istep * c0_0[1] + step * c0_1[1]);
                var b1 = Math.round(istep * c0_0[2] + step * c0_1[2]);
                var color1 = "rgb(" + r1 + "," + g1 + "," + b1 + ")";

                var r2 = Math.round(istep * c1_0[0] + step * c1_1[0]);
                var g2 = Math.round(istep * c1_0[1] + step * c1_1[1]);
                var b2 = Math.round(istep * c1_0[2] + step * c1_1[2]);
                var color2 = "rgb(" + r2 + "," + g2 + "," + b2 + ")";

                if (!isIE) {
                    $('.header-curve .ocean').css({
                        'background': color1,
                        'background-image': "-moz-linear-gradient(right top, " + color1 + " 0%," + color2 + " 100%)",
                        'background-image': "-webkit-gradient(linear, right top, left bottom, color-stop(0, " +
                            color1 +
                            "), color-stop(1, " +
                            color2 +
                            "))",
                        'background': "-webkit-linear-gradient(right top, " + color1 + " 0%, " + color2 + " 100%)",
                        'background': "-o-linear-gradient(right top, " + color1 + " 0%, " + color2 + " 100%)",
                        'background': "-ms-linear-gradient(right top, " + color1 + " 0%, " + color2 + " 100%)",
                        'background': "linear-gradient(right top, " + color1 + " 0%, " + color2 + " 100%)"

                        //background: "-webkit-gradient(linear, left top, right top, from(" + color1 + "), to(" + color2 + "))"
                    }).css({
                        background: "-moz-linear-gradient(left, " + color1 + " 0%, " + color2 + " 100%)"
                    });
                }

                step += gradientSpeed;
                if (step >= 1) {
                    step %= 1;
                    colorIndices[0] = colorIndices[1];
                    colorIndices[2] = colorIndices[3];

                    //pick two new target color indices
                    //do not pick the same as the current one
                    colorIndices[1] = (colorIndices[1] + Math.floor(1 + Math.random() * (colors.length - 1))) % colors.length;
                    colorIndices[3] = (colorIndices[3] + Math.floor(1 + Math.random() * (colors.length - 1))) % colors.length;

                }
            }

            setInterval(updateGradient, 10);

            var previousScroll = 0, // previous scroll position
                menuOffset = 54, // height of menu (once scroll passed it, menu is hidden)
                detachPoint = 650, // point of detach (after scroll passed it, menu is fixed)
                hideShowOffset = 6; // scrolling value after which triggers hide/show menu

            // on scroll hide/show menu
            $(window).scroll(function () {
                if ($('nav').hasClass('expanded')) {
                    // do nothing; main navigation is being shown
                } else {
                    var currentScroll = $(this).scrollTop(), // gets current scroll position
                        scrollDifference = Math.abs(currentScroll - previousScroll); // calculates how fast user is scrolling

                    // if scrolled past menu
                    if (currentScroll > menuOffset) {
                        // if scrolled past detach point add class to fix menu
                        if (currentScroll > detachPoint) {
                            $('nav').addClass('detached');
                        }

                        // if scrolling faster than hideShowOffset hide/show menu
                        if (scrollDifference >= hideShowOffset) {
                            if (currentScroll > previousScroll) {
                                // scrolling down; hide menu
                                $('nav').addClass('invisible');
                            } else {
                                // scrolling up; show menu
                                $('nav').removeClass('invisible');
                            }
                        }
                    } else {
                        // only remove “detached” class if user is at the top of document (menu jump fix)
                        if (currentScroll <= 0) {
                            $('nav').removeClass();
                        }
                    }

                    // if user is at the bottom of document show menu
                    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
                        $('nav').removeClass('invisible');
                    }

                    // replace previous scroll position with new one
                    previousScroll = currentScroll;
                }
            })

            // shows/hides navigation’s popover if class "expanded"
            $('nav li.nav_item').click(function() {
                showHideNav();
            });

            // clicking anywhere inside navigation or heading won’t close navigation’s popover
            $('#navigation').click(function(event) {
                event.stopPropagation();
            });

            // checks if navigation’s popover is shown
            function showHideNav() {
                if ($('nav').hasClass('expanded')) {
                    hideNav();
                } else {
                    showNav();
                }
            }

            // shows the navigation’s popover
            function showNav() {
                $('nav').removeClass('invisible').addClass('expanded');
                $('#container').addClass('blurred');
                window.setTimeout(function () { $('body').addClass('no_scroll'); }, 200); // Firefox hack. Hides scrollbar as soon as menu animation is done
                $('#navigation a').attr('tabindex', ''); // links inside navigation should be TAB selectable
            }

            // hides the navigation’s popover
            function hideNav() {
                $('#container').removeClass('blurred');
                window.setTimeout(function () { $('body').removeClass(); }, 10); // allow animations to start before removing class (Firefox)
                $('nav').removeClass('expanded');
                $('#navigation a').attr('tabindex', '-1'); // links inside hidden navigation should not be TAB selectable
                $('.icon').blur(); // deselect icon when navigation is hidden
            }

            // keyboard shortcuts
            $('body').keydown(function (e) {
                // menu accessible via TAB as well
                if ($("nav .icon").is(":focus")) {
                    // if ENTER/SPACE show/hide menu
                    if (e.keyCode === 13 || e.keyCode === 32) {
                        showHideNav();
                        e.preventDefault();
                    }
                }

                // if ESC show/hide menu
                if (e.keyCode === 27) {
                    showHideNav();
                }
            })
        }
    }
})();



//////////////////
// WEBPACK FOOTER
// ./Views/Blocks/HomeHeroBlock/_heroGradient.js
// module id = 24
// module chunks = 0